import $ from "jquery";

$(() => {
  $('a.post-category').on('click', function (e) {
    e.preventDefault();

    const chosenId = $(this).attr('data-category-id');

    // categories
    $('a.post-category').each(function (element) {
      if (!$(this).hasClass('opacity-50')) {
        $(this).addClass('opacity-50');
      }

      const currentId = $(this).attr('data-category-id');
      if (currentId === chosenId) {
        $(this).removeClass('opacity-50');
      }
    });

    // posts
    if (chosenId === '0') {
      $('a.learn-card').show();
    } else {
      $('a.learn-card').hide(); // hide all

      // loop to show only correct posts
      $('a.learn-card').each(function (element) {
        const postCategoryId = $(this).attr('data-category-id');
        if (chosenId === postCategoryId) {
          $(this).show();
        }
      });
    }
  });
});
